import getUserModel from './user'

const staffEmployee = {
  id: null,
  user: { ...getUserModel() },
  userId: null,
  commissionTiers: [],
  employeeTypeId: null,
  corporateName: null,
  ein: null,
  payAmount: null,
  payTypeId: null,
  payFrequencyId: null,
  workedHoursAverage: null,
  corporateEmailAddress: null,
  active: null,
  startDate: null,
  endDate: null,
  zohoUserId: null
}

export default () => Object.assign({}, staffEmployee)
